import { createAction, props } from "@ngrx/store";
import { Login } from "../models/login.model";


export const enter = createAction(
    '[Login Page] Entered the page'
);

export const login = createAction(
    '[Login Page] User Login',
    props<{ login: Login }>()
);


// Segunda etapa: código de 6 dígitos OU código de recuperação (um dos dois)
export const loginMfa = createAction(
    '[Login Page] User MFA Login',
    props<{ code?: string; recoveryCode?: string }>()
);

// Usuário clicou em "Voltar" na segunda etapa
export const mfaCancel = createAction(
    '[Login Page] MFA Cancel'
);
